//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import { INgRedux } from 'ng-redux';

import getGalleriesClientType from '@galleries/selectors/getGalleriesClientType';
import { getFeatureNames, Plurality } from './utils';

// This directive will compile down to a TextNode, i.e it will have no DOM element
angular.module('curalate').directive('fanreelProductName', [
  '$ngRedux',
  (
    $ngRedux: INgRedux,
  ) => ({
    replace: true,
    restrict: 'E',
    scope: {
      singularize: '@?',
      pluralize: '@?',
    },
    template: '<span>Fanreel</span>', // Should not be used, fallback only.
    link: (scope, element, attrs)  => {
      const isPlural = attrs.pluralize !== undefined;
      const isSingular = attrs.singularize !== undefined;
      const clientType = getGalleriesClientType($ngRedux.getState());

      const getSingularOrPlural = (): Plurality => {
        if (isPlural) {
          return Plurality.plural;
        } else if (isSingular) {
          return Plurality.singular;
        } else {
          return Plurality.default;
        }
      };

      const text = getFeatureNames(clientType)[getSingularOrPlural()];
        // Create a text node and replace this directive with it.
      const el = element[0];
      el.parentNode.replaceChild(document.createTextNode(text), el);
    },
  }),
]);
